<template>
  <header>
    <img class="ui small image" src="../assets/name.png">
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
    }
  },
  created() {
  },
  watch: {
  },
  methods: {
    showMenuHeader() {
     
    },
  }
}
</script>

<style scoped>
header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom:1px solid gray;
  /* background-color: #00f9a9; */
}

img {
  padding: 10px;
}

</style>
